import { render } from "./BlogPageThree.vue?vue&type=template&id=128cc327"
import script from "./BlogPageThree.vue?vue&type=script&lang=js"
export * from "./BlogPageThree.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pavithram.org/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__